import { css } from '@emotion/css';

const wrapper = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '1rem',
  padding: 'var(--spacings-1)',
  width: '100%',
});

const TransactionalProfileStyles = {
  wrapper,
};

export default TransactionalProfileStyles;
